export const DEFAULT_PRECISION = 15
export const DEFAULT_SCALE = 2

export function resolveNumberDigits(props?: Record<string, unknown>): { precision: number; scale: number } {
  const precision = Number(props?.precision)
  const scale = Number(props?.scale)
  return {
    precision: Number.isFinite(precision) && precision > 0 ? Math.floor(precision) : DEFAULT_PRECISION,
    scale: Number.isFinite(scale) && scale >= 0 ? Math.floor(scale) : DEFAULT_SCALE,
  }
}

export function parseNumberInput(raw: string): number | null {
  const t = raw.trim()
  if (t === '') return null
  const n = Number(t)
  return Number.isFinite(n) ? n : null
}

export function clampNumber(n: number, precision: number, scale: number): number {
  const factor = 10 ** scale
  const rounded = Math.round(n * factor) / factor
  const maxAbs = 10 ** Math.max(precision - scale, 1) - 10 ** -scale
  if (!Number.isFinite(maxAbs) || maxAbs <= 0) return rounded
  if (rounded > maxAbs) return maxAbs
  if (rounded < -maxAbs) return -maxAbs
  return rounded
}

export function formatNumberDisplay(n: number | null, precision: number, scale: number): string {
  if (n == null || Number.isNaN(n)) return ''
  return clampNumber(n, precision, scale).toFixed(scale)
}

export function applyNumberBlur(
  raw: string,
  previous: number | null,
  precision: number,
  scale: number,
): number | null {
  if (raw.trim() === '') return null
  const parsed = parseNumberInput(raw)
  if (parsed == null) return previous
  return clampNumber(parsed, precision, scale)
}
